import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  IconButton,
  Image,
  Text,
  Textarea
} from '@chakra-ui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { DeleteIcon } from '../../components/Shared/Icons'
import _ from 'lodash'

const RenderImageContainer = ({
  images,
  haveComments = true,
  getNewArray = () => {},
  getNewArrayDelete = () => {}
}) => {
  const getFilename = (img) => {
    const index = img.lastIndexOf('/') + 1
    let filename = img.substr(index)
    const ext = filename.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)?.[1] || '..'
    if (filename.length > 22) {
      filename = `${filename.slice(0, 20)}..`
    }

    return `${filename}${ext}`
  }

  const handleChangeImages = (event, position) => {
    const { name, value } = event.target
    const newArray = _.cloneDeep(images)
    newArray[position] = {
      ...newArray[position],
      [name]: value
    }
    getNewArray(newArray)
  }

  const handleDeleteImages = (position) => {
    const newArray = _.cloneDeep(images)
    newArray.splice(position, 1)
    getNewArrayDelete(newArray)
  }

  const moveImage = (index, direction) => {
    const newIndex = direction === 'up' ? index - 1 : index + 1
    if (newIndex < 0 || newIndex >= images.length) return

    const newArray = _.cloneDeep(images)
    const [moved] = newArray.splice(index, 1)
    newArray.splice(newIndex, 0, moved)
    getNewArray(newArray)
  }

  const canReorder = images.length > 1

  return (
    <Flex
      direction="column"
      justify="center"
      alignItems="center"
      gap={2}
      w="100%"
    >
      {canReorder && (
        <Text fontSize="xs" color="#666587" w="100%" mb={1}>
          Usa las flechas para cambiar el orden de las fotos.
        </Text>
      )}
      {images.map((img, idx) => (
        <Box w="100%" pb={5} borderRadius={'lg'} boxShadow={'md'} key={img.url}>
          <Flex gap={2} justify="space-between" p={2} align="center">
            <HStack>
              {canReorder && (
                <HStack spacing={1}>
                  <Text fontSize="sm" fontWeight="bold" color="#36355F">
                    {idx + 1}
                  </Text>
                  <IconButton
                    aria-label="Subir imagen"
                    icon={<ChevronUpIcon />}
                    size="xs"
                    isDisabled={idx === 0}
                    onClick={() => moveImage(idx, 'up')}
                  />
                  <IconButton
                    aria-label="Bajar imagen"
                    icon={<ChevronDownIcon />}
                    size="xs"
                    isDisabled={idx === images.length - 1}
                    onClick={() => moveImage(idx, 'down')}
                  />
                </HStack>
              )}
              <Image
                src={img.url}
                alt="Imagen"
                height={'20px'}
                width={'40px'}
                onClick={() => window.open(img.url, '_blank')}
                cursor="pointer"
              />
              <Text>{getFilename(img.url)}</Text>
            </HStack>
            <IconButton
              icon={<Icon fontSize="22" as={DeleteIcon} />}
              onClick={() => handleDeleteImages(idx)}
            />
          </Flex>
          {haveComments && (
            <FormControl id="observation">
              <FormLabel>Observaciones</FormLabel>
              <Textarea
                name="observation"
                value={img.observation}
                onChange={(event) => handleChangeImages(event, idx)}
                placeholder="Observaciones"
              />
            </FormControl>
          )}
        </Box>
      ))}
    </Flex>
  )
}

export default RenderImageContainer
